import { Box, Image } from '@chakra-ui/react';
import { HStack } from 'components/ui';

const images = [
  {
    source: '/time.png',
    alt: 'TIME Health Magazine',
    width: '90px',
    height: '32px',
  },
  {
    source: '/fierce_healthcare.png',
    alt: 'Fierce Healthcare',
    width: '111px',
    height: '45px',
  },
  {
    source: '/vogue.png',
    alt: 'Vogue Magazine',
    width: '133px',
    height: '30px',
  },
  { source: '/axios.png', alt: 'Axios', width: '133px', height: '34px' },
  { source: '/glamour.png', alt: 'Glamour', width: '154px', height: '27px' },
];

export const FeaturedBar = () => {
  return (
    <Box w="100vw" backgroundColor="#E7E7E7" mt={{ base: 0, lg: '86px' }}>
      <HStack
        flexWrap={{ base: 'wrap', lg: 'nowrap' }}
        py={4}
        w="100%"
        maxWidth={{ base: 'auto', lg: '80%' }}
        mx={'auto'}
        alignItems={'center'}
        justifyContent={{ base: 'center', lg: 'space-evenly' }}
      >
        {images.map(({ source, alt, width, height }) => (
          <Image
            key={alt}
            src={source}
            alt={alt}
            width={width}
            height={height}
            my={4}
            mx={4}
          />
        ))}
      </HStack>
    </Box>
  );
};
